import storageApi from "@/api/storage";
import { AIFilter } from "@/interfaces/ai-filter.interface";

const AI_FILTER_JSON_PATH = "library/ai-filters";

export const uploadAIFilterJson = async (filter: AIFilter) => {
  if (!filter?._id) return;

  const fileName = `${filter._id}.json`;
  const file = new File([JSON.stringify(filter, null, 2)], fileName, {
    type: "application/json",
  });

  await storageApi.uploadFile(
    file,
    AI_FILTER_JSON_PATH,
    fileName,
    "application/json",
  );
};
